module.exports = __webpack_public_path__ + "img/LOGO-IGNIS-DARKBG.5697c618.svg";